/* eslint-disable react/display-name */
import clsx from 'clsx'
import { forwardRef, DetailedHTMLProps, InputHTMLAttributes, useState } from 'react'
import { FieldErrorsImpl, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import EyeIcon from '../icons/EyeIcon'
import EyeSlashIcon from '../icons/EyeSlashIcon'

type InputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  errors: FieldErrorsImpl<FieldValues>
  lableTitle: string
  classess?: string
}

type Ref = HTMLInputElement
const InputPasswordField = forwardRef<Ref, InputProps>(({ errors, lableTitle, ...props }, ref) => {
  const { t } = useTranslation()
  const { name } = props

  const [inputType, setInputType] = useState<string>('password')

  const handleChangeInputType = () => {
    inputType === 'password' ? setInputType('text') : setInputType('password')
  }
  return (
    <div className='relative w-full flex flex-col'>
      <label className='text-xs mr-3 mb-2.5' htmlFor={name}>
        {lableTitle}
      </label>
      <input
        ref={ref}
        className={clsx(
          'text-gray-500 border-2 rounded-lg text-sm px-2.5 py-2 placeholder:text-gray-300 text-center',
          errors[name ?? '']?.message && errors[name ?? '']?.type
            ? 'focus-shadow--invalid invalid'
            : 'focus-shadow  border-gray-200',
        )}
        type={inputType}
        {...props}
      />
      {errors[name ?? '']?.message ? (
        <p className='absolute bottom-8 text-xs mr-3 mt-2 text-red-400 bg-white px-1 rounded'>
          {t(`${errors[name ?? ' ']?.message}`)}
        </p>
      ) : null}
      <div
        className='absolute top-9 left-3 text-gray-300 hover:text-gray-400 ease-in-out duration-200 cursor-pointer'
        onClick={handleChangeInputType}
      >
        {inputType === 'password' ? <EyeSlashIcon /> : <EyeIcon />}
      </div>
    </div>
  )
})

export default InputPasswordField
